import { render, staticRenderFns } from "./CalendeskImageSelectV2.vue?vue&type=template&id=62d36ffc&scoped=true"
import script from "./CalendeskImageSelectV2.vue?vue&type=script&lang=ts"
export * from "./CalendeskImageSelectV2.vue?vue&type=script&lang=ts"
import style0 from "./CalendeskImageSelectV2.vue?vue&type=style&index=0&id=62d36ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d36ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
